export enum UserRoles {
  admin = 1,
  manager = 0,
}

export const RolesMap = {
  [UserRoles.admin]: 'Админ',
  [UserRoles.manager]: 'Менеджер',
};
